import { WidgetType } from '../widgets/shared/types';
import { WidgetLayout } from '../widgets/useWidgetLayout';
import {
  defaultWidgetLayouts,
  widgetSizeConstraints,
} from '../widgets/defaultWidgetLayouts';

const customerWidgetSizeConstraints = {
  articles: {
    lg: {
      w: 12,
      h: 10,
      minH: 3,
      minW: 4,
      maxH: 12,
    },
  },
  samples: {
    lg: {
      w: 12,
      h: 4,
      minW: 4,
    },
  },
  inquiries: {
    lg: {
      w: 12,
      h: 4,
      minW: 4,
    },
  },
  paRejectionReasons: {
    lg: {
      w: 6,
      h: 4,
      minH: 3,
      minW: 4,
    },
  },
};

export const getDefaultConceptWidgetsLayout = (): WidgetLayout => {
  return {
    layout: {
      lg: [
        {
          ...customerWidgetSizeConstraints.articles.lg,
          x: 0,
          y: 4,
          i: '0',
        },
        {
          ...customerWidgetSizeConstraints.samples.lg,
          x: 0,
          y: 0,
          i: 'samples',
        },
        {
          ...customerWidgetSizeConstraints.inquiries.lg,
          x: 0,
          y: 4,
          i: 'inquiries',
        },
      ],
    },
    widgets: [
      {
        type: WidgetType.Articles,
        id: '0',
        layoutIndex: '0',
        name: WidgetType.Articles,
        categoryColor: null,
      },
      {
        type: WidgetType.TrackSamples,
        id: 'samples',
        layoutIndex: 'samples',
        name: WidgetType.TrackSamples,
        categoryColor: null,
      },
      {
        type: WidgetType.TrackInquiries,
        id: 'inquiries',
        layoutIndex: 'inquiries',
        name: WidgetType.TrackInquiries,
        categoryColor: null,
      },
    ],
  };
};

export const getDefaultCustomerWidgetsLayout = (): WidgetLayout => {
  return {
    layout: {
      lg: [
        {
          ...customerWidgetSizeConstraints.articles.lg,
          x: 0,
          y: 4,
          i: '0',
        },
        {
          ...customerWidgetSizeConstraints.samples.lg,
          x: 0,
          y: 0,
          i: 'samples',
        },
        {
          ...customerWidgetSizeConstraints.inquiries.lg,
          x: 0,
          y: 4,
          i: 'inquiries',
        },
        {
          ...defaultWidgetLayouts.productApprovalsCount.lg,
          ...widgetSizeConstraints.productApprovalsCount,
          i: 'productApprovalsCount',
        },
        {
          ...defaultWidgetLayouts.productApprovalLeadTime.lg,
          ...widgetSizeConstraints.productApprovalLeadTime,
          i: 'productApprovalLeadTime',
        },
        {
          ...defaultWidgetLayouts.productApprovalRatio.lg,
          ...widgetSizeConstraints.productApprovalRatio,
          i: 'productApprovalRatio',
        },
        {
          ...defaultWidgetLayouts.articleProgress.lg,
          ...widgetSizeConstraints.articleProgress,
          i: 'articleProgress',
        },
        {
          ...defaultWidgetLayouts.paLeadTimeDistribution.lg,
          ...widgetSizeConstraints.paLeadTimeDistribution,
          i: 'paLeadTimeDistribution',
        },
      ],
    },
    widgets: [
      {
        type: WidgetType.Articles,
        id: '0',
        layoutIndex: '0',
        name: WidgetType.Articles,
        categoryColor: null,
      },
      {
        type: WidgetType.TrackSamples,
        id: 'samples',
        layoutIndex: 'samples',
        name: WidgetType.TrackSamples,
        categoryColor: null,
      },
      {
        type: WidgetType.TrackInquiries,
        id: 'inquiries',
        layoutIndex: 'inquiries',
        name: WidgetType.TrackInquiries,
        categoryColor: null,
      },
      {
        type: WidgetType.ProductApprovalsCount,
        id: 'productApprovalsCount',
        layoutIndex: 'productApprovalsCount',
        name: WidgetType.ProductApprovalsCount,
        categoryColor: null,
      },
      {
        type: WidgetType.ProductApprovalLeadTime,
        id: 'productApprovalLeadTime',
        layoutIndex: 'productApprovalLeadTime',
        name: WidgetType.ProductApprovalLeadTime,
        categoryColor: null,
      },
      {
        type: WidgetType.ProductApprovalRatio,
        id: 'productApprovalRatio',
        layoutIndex: 'productApprovalRatio',
        name: WidgetType.ProductApprovalRatio,
        categoryColor: null,
      },
      {
        type: WidgetType.ArticleProgress,
        id: 'articleProgress',
        layoutIndex: 'articleProgress',
        name: WidgetType.ArticleProgress,
        categoryColor: null,
      },
      {
        type: WidgetType.PaLeadTimeDistribution,
        id: 'paLeadTimeDistribution',
        layoutIndex: 'paLeadTimeDistribution',
        name: WidgetType.PaLeadTimeDistribution,
        categoryColor: null,
      },
    ],
  };
};
